<template>
  <div class="resources-container">
    <h2>دروس هامة وشروحات وأسئلة الدورات على التلغرام</h2>

    <!-- قسم الدروس -->
    <div class="card">
      <h3>📖 دروس مهمة</h3>
      <div class="links">
        <a v-for="(lesson, i) in lessons" :key="i" :href="lesson.url" target="_blank" rel="noopener">
          {{ lesson.title }}
        </a>
      </div>
    </div>

    <!-- قسم الدورات -->
    <div class="card">
      <h3>🎓 دورات محلولة</h3>
      <div class="links">
        <a v-for="(exam, i) in exams" :key="i" :href="exam.url" target="_blank" rel="noopener">
          {{ exam.title }}
        </a>
      </div>
    </div>

    <div class="back">
      <router-link to="/">⬅️ رجوع</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourcesPage',
  data() {
    return {
      // 📘 دروس عامة للمقدرة اللغوية
      lessons: [
        { title: "📘 محاضرة أكاديمية: مرجع شامل وهام جدًا في جميع الأزمنة", url: "https://t.me/textbac12/345" },
        { title: "📘 درس هام جدًا في الأفعال الشاذة وتصريفاتها", url: "https://t.me/textbac12/344" },
        { title: "المرجع الشامل للأفعال الناقصة – Modal Verbs Explained Clearly", url: "https://t.me/textbac12/347" },
        { title: "درس هام عن الجمل الشرطية", url: "https://t.me/textbac12/163" },
        { title: "أدوات الربط (Linking Words / Conjunctions)", url: "https://t.me/textbac12/165" },
        { title: "🔥 كلمات الربط الأساسية في امتحان الماجستير – شرح شامل مع أمثلة لا تُنسى!", url: "https://t.me/textbac12/273" },
        { title: "الدرس الذهبي في لواحق الكلمات الإنجليزية – English Suffixes", url: "https://t.me/textbac12/342" },
        { title: "درس اليوم: أحرف الجر", url: "https://t.me/textbac12/312" },
        { title: "الدرس عن الكلام المنقول", url: "https://t.me/textbac12/314" },
        { title: "الدرس عن جمل الشرط", url: "https://t.me/textbac12/315" },
        { title: "📚 درس شامل: Phrasal Verbs + Prepositions في النصوص الأكاديمية", url: "https://t.me/textbac12/343" },
        { title: "درس اليوم: تحويل المبني للمعلوم للمجهول", url: "https://t.me/textbac12/326" },
        { title: "🔵 استخدام اللغة – درس هام", url: "https://t.me/textbac12/328" },
        { title: "تمارين هامة 1", url: "https://t.me/textbac12/157" },
        { title: "تمارين هامة 2", url: "https://t.me/textbac12/159" },
        { title: "تمارين هامة 3", url: "https://t.me/textbac12/161" },
        { title: "📚 درس إضافي: Phrasal Verbs + Prepositions (رابط آخر)", url: "https://t.me/textbac12/316" },
       
      ],

      // 🎓 أسئلة الدورات المحلولة
      
    }
  }
}
</script>


<style scoped>
.resources-container { min-height: 100vh; background: #000; color: #f9e7b3; padding: 2rem 1rem; font-family: 'Tajawal', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
h2 { text-align: center; margin-bottom: 1rem; font-weight: 800; letter-spacing: 0.5px; font-size: 1.6rem; background: linear-gradient(180deg,#e1c31b 50%,#e4b807 100%,#f9d648 70%,#d4af37 60%); -webkit-background-clip: text; background-clip: text; color: transparent; text-shadow: 0 1px 2px rgba(0,0,0,0.66),0 -1px 1px rgba(255,255,255,0.3); }
.card { max-width: 720px; margin: 0.8rem auto; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 18px; padding: 1rem; box-shadow: 0 6px 18px rgba(0,0,0,0.6); }
.card h3 { margin-bottom: 0.6rem; color: #ffe680; font-size: 1.2rem; }
.links { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 0.6rem; }
.links a { display: block; padding: 0.7rem 0.9rem; color: #f9e7b3; text-decoration: none; background: linear-gradient(180deg, #1c1c1e, #0e0e0f); border: 1px solid rgba(212,175,55,0.6); border-radius: 12px; transition: 0.25s; text-align: center; font-weight: 600; }
.links a:hover { background: linear-gradient(180deg, #2a2a2c, #0e0e0f); color: #ffe680; transform: translateY(-2px); }
.back { text-align: center; margin-top: 1rem; }
.back a { color: #ffe680; text-decoration: none; font-weight: 700; }
</style>
